import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { CardInfo } from '@angeplus/prever-component-lib';

type PlansFeaturesItemProps = {
  icon?: ReactNode;
  title?: string;
  body?: string;
};

const PlansFeaturesItem = (props: PlansFeaturesItemProps) => {
  return (
    <CardInfoStyled title={props.title} icon={props.icon}>
      {props.body}
    </CardInfoStyled>
  );
};

const CardInfoStyled = styled(CardInfo)`
  width: 100%;
  height: 100%;
`;

export default PlansFeaturesItem;
